var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7503 11.0001C15.7762 11.0001 17.417 9.35925 17.417 7.33341C17.417 5.30758 15.7762 3.66675 13.7503 3.66675C11.7245 3.66675 10.0837 5.30758 10.0837 7.33341C10.0837 9.35925 11.7245 11.0001 13.7503 11.0001ZM5.50033 9.16675V7.33341C5.50033 6.82925 5.08783 6.41675 4.58366 6.41675C4.07949 6.41675 3.66699 6.82925 3.66699 7.33341V9.16675H1.83366C1.32949 9.16675 0.916992 9.57925 0.916992 10.0834C0.916992 10.5876 1.32949 11.0001 1.83366 11.0001H3.66699V12.8334C3.66699 13.3376 4.07949 13.7501 4.58366 13.7501C5.08783 13.7501 5.50033 13.3376 5.50033 12.8334V11.0001H7.33366C7.83783 11.0001 8.25033 10.5876 8.25033 10.0834C8.25033 9.57925 7.83783 9.16675 7.33366 9.16675H5.50033ZM13.7503 12.8334C11.3028 12.8334 6.41699 14.0617 6.41699 16.5001V17.4167C6.41699 17.9209 6.82949 18.3334 7.33366 18.3334H20.167C20.6712 18.3334 21.0837 17.9209 21.0837 17.4167V16.5001C21.0837 14.0617 16.1978 12.8334 13.7503 12.8334Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAddIcon);
export default __webpack_public_path__ + "static/media/PersonAddIcon.5efb086d16c91ae0f82d703dea9e1ea5.svg";
export { ForwardRef as ReactComponent };